export enum OrderType {
  AWAITING_PROCUREMENT = 'AWAITING_PROCUREMENT',
  INTEGRATING_AND_TESTING = 'INTEGRATING_AND_TESTING',
  PACKING = 'PACKING',
  IN_TRANSIT = 'IN_TRANSIT',
  RECEIVED_BY_CUSTOMER = 'RECEIVED_BY_CUSTOMER',
  BRINGUP_DONE = 'BRINGUP_DONE',
}
